
import { Content } from '@/types/content';
import { Story } from '@/utils/storiesData';
import contentfulService from '@/services/contentfulService';
import youtubeApi from '@/utils/youtubeApi';

export const searchContent = async (query: string): Promise<Content[]> => {
  const lowerQuery = query.toLowerCase();
  
  try {
    const youtubeResults = await youtubeApi.searchVideos(query);
    const combinedResults = [...youtubeResults];
    const uniqueResults = Array.from(
      new Map(combinedResults.map(item => [item.id, item])).values()
    );
    return uniqueResults.slice(0, 12);
  } catch (error) {
    console.error('YouTube search error:', error);
    return [];
  }
};

export const searchStories = async (query: string): Promise<Story[]> => {
  const lowerQuery = query.toLowerCase();
  const searchTerms = lowerQuery.split(' ').filter(term => term.length > 1);
  
  try {
    const contentfulStories = await contentfulService.getStories();
    const contentfulResults = contentfulStories.filter(story => {
      const contentMatches = searchTerms.some(term => 
        story.title.toLowerCase().includes(term) || 
        story.content.toLowerCase().includes(term) || 
        story.excerpt.toLowerCase().includes(term) || 
        story.author.name.toLowerCase().includes(term) || 
        story.category.toLowerCase().includes(term)
      );
      
      const tagMatches = story.tags && Array.isArray(story.tags) && story.tags.some(tag => {
        if (typeof tag === 'string') {
          return tag.toLowerCase().includes(lowerQuery);
        }
        return false;
      });
      
      return contentMatches || tagMatches;
    });
    
    return contentfulResults.slice(0, 12);
  } catch (error) {
    console.error('Contentful search error:', error);
    return [];
  }
};
